import { render, staticRenderFns } from "./SvgCircle.vue?vue&type=template&id=347c35b9&scoped=true"
import script from "./SvgCircle.vue?vue&type=script&lang=js"
export * from "./SvgCircle.vue?vue&type=script&lang=js"
import style0 from "./SvgCircle.vue?vue&type=style&index=0&id=347c35b9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c35b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347c35b9')) {
      api.createRecord('347c35b9', component.options)
    } else {
      api.reload('347c35b9', component.options)
    }
    module.hot.accept("./SvgCircle.vue?vue&type=template&id=347c35b9&scoped=true", function () {
      api.rerender('347c35b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SvgCircle/SvgCircle.vue"
export default component.exports